var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 4.46875C13.4217 4.46875 11.5366 5.41441 10.3125 6.99359V5.15625C10.3125 2.31309 7.99941 0 5.15625 0C2.31309 0 0 2.31309 0 5.15625V16.8438C0 19.6869 2.31309 22 5.15625 22C7.99941 22 10.3125 19.6869 10.3125 16.8438V15.0064C11.5366 16.5856 13.4217 17.5312 15.4688 17.5312C19.0702 17.5312 22 14.6015 22 11C22 7.39853 19.0702 4.46875 15.4688 4.46875ZM5.15625 21.3125C2.69225 21.3125 0.6875 19.3077 0.6875 16.8438V11H9.625V16.8438C9.625 19.3077 7.62025 21.3125 5.15625 21.3125ZM10.3125 13.7479V8.25206C10.4778 7.942 10.6707 7.65325 10.8828 7.38341L19.0826 15.5832C18.0871 16.3701 16.8331 16.8438 15.4688 16.8438C13.2997 16.8438 11.3324 15.6588 10.3125 13.7479ZM20.052 14.6138L11.8491 6.41094C12.8607 5.61137 14.1257 5.15625 15.4688 5.15625C18.6911 5.15625 21.3125 7.77769 21.3125 11C21.3125 12.3643 20.8388 13.6183 20.052 14.6138Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 5.15625C0.6875 2.68823 2.68823 0.6875 5.15625 0.6875C7.62427 0.6875 9.625 2.68823 9.625 5.15625V10.6562H0.6875V5.15625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientMedicationIcon);
export default __webpack_public_path__ + "static/media/PatientMedicationIcon.b2e676bc0691f157e655c1f2b2b4e650.svg";
export { ForwardRef as ReactComponent };